const easterEggMessageTriggers: Record<string, string> = {
    'Que fait Robin ?': 'Très probablement en train de préparer un latte macchiato ☕️',
    'Qui est Dorian ?': "Mon créateur, ou peut-être devrais-je l'appeler Papa ?!",
    'Je suis Dorian': 'Papa ?!',
};

export function hasEasterEggMessageTrigger(message: string): boolean {
    return easterEggMessageTriggers[message] !== undefined;
}

export function getEasterEggMessage(message: string): string {
    return easterEggMessageTriggers[message];
}
